module.exports = __webpack_public_path__ + "static/img/login2.ab1eb756.png";